import React from 'react';
import { WrenchIcon, AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { audiences } from '../../data/pathway';
export function Audience() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="audience-title" data-id="element-62" data-mp="1dukqaa4ei64m">
      <div className="mx-auto max-w-4xl px-5" data-id="element-63" data-mp="1hyse8531bi1s">
        <SectionHeading kicker="Built for HVAC professionals who want a more structured process" title={<span id="audience-title" data-id="element-65" data-mp="2an6fctpf6uhk">Who is this blueprint for?</span>} data-id="element-64" data-mp="25o3bvdp38wbp" />

        <ul className="mt-12 divide-y divide-line overflow-hidden rounded-3xl border border-line bg-ink" data-id="element-66" data-mp="1wnf6169um29w">
          {audiences.map(a => <li key={a.role} className="flex items-start gap-4 p-5 sm:p-6" data-id="element-67" data-mp="21kx4g2q8oz3n">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-volt/15" data-id="element-68" data-mp="l7qhwbkuyx7i">
                <WrenchIcon className="h-5 w-5 text-volt" aria-hidden="true" data-id="element-69" data-mp="q84ft0sqwqrt" />
              </span>
              <div data-id="element-70" data-mp="zncoay2q85n7">
                <h3 className="font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-71" data-mp="zmtgwbapcznf">{a.role}</h3>
                <p className="mt-1 text-[16px] leading-relaxed text-mist" data-id="element-72" data-mp="up1iqzjgshas">{a.body}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-amber/40 bg-amber/10 p-5" data-id="element-73" data-mp="14kv0qyfyd2zy">
          <AlertTriangleIcon className="mt-0.5 h-6 w-6 shrink-0 text-amber" aria-hidden="true" data-id="element-74" data-mp="1ikdxyw786txh" />
          <p className="text-[15px] leading-relaxed text-white" data-id="element-75" data-mp="1dmujbv6m8f50">
            <strong className="text-amber" data-id="element-76" data-mp="1dk89tq05zpk5">Important:</strong> This product is intended for trained, qualified
            professionals. It is not an introductory electrical training course, a substitute for professional
            certification, or authorization to perform hazardous electrical work.
          </p>
        </div>

        <TransformCta label="This is for me — get instant access" data-id="element-77" data-mp="1xalf98lhy6wl" />
      </div>
    </section>;
}